import { j as m, b as ae, k as Z, d as Dt, n as $t, I as Ut, p as Q, l as ee, A as Le, O as kt, T as Ht, m as it, h as lt, c as qt, e as Vt, a as Ft, f as Bt, C as Wt, o as zt, q as _e, g as Yt, P as Kt } from "./index-CoDGs-6l.js";
import he, { forwardRef as te, useMemo as Xt, useState as Jt } from "react";
const Gt = "_root_1hemh_12", Zt = "_content_1hemh_19", Qt = "_title_1hemh_22", er = "_body_1hemh_31", tr = "_iconButton_1hemh_39", rr = "_icon_1hemh_39", oe = {
  root: Gt,
  content: Zt,
  title: Qt,
  body: er,
  iconButton: tr,
  icon: rr
}, ct = "ActionCard";
function ut({ title: a, body: l, action: y, className: u, ...v }, r) {
  const { icon: o } = y ?? {};
  function h(d) {
    const { type: O, url: S } = d ?? {};
    switch (O) {
      case "navigate":
        return {
          ariaLabel: "External link",
          as: "a",
          href: S ?? "",
          target: "_blank",
          rel: "noopener noreferrer"
        };
      case "call":
        return {
          ariaLabel: "Phone number call link",
          as: "a",
          href: S ?? "",
          target: "_self"
        };
      case "copy":
        return {
          ariaLabel: "Copy to clipboard",
          onClick: async function() {
            l && (await navigator.clipboard.writeText(l), window.alert(`Ora puoi incollare ${l} `));
          }
        };
      default:
        return {};
    }
  }
  return /* @__PURE__ */ m.jsx(
    ae,
    {
      ref: r,
      className: Z(
        "airc-ui__" + Q(ct),
        ee(u)
      ),
      ...v,
      style: {
        ...v.style ? v.style : {},
        border: "1px solid var(--airc-ui__colors-grey-grey-100)",
        boxShadow: "none",
        borderRadius: "var(--airc-ui__radius-m)"
      },
      children: /* @__PURE__ */ m.jsxs("div", { className: oe.root, children: [
        /* @__PURE__ */ m.jsxs("div", { className: oe.content, children: [
          a ? /* @__PURE__ */ m.jsx("div", { className: oe.title, children: a }) : null,
          l ? /* @__PURE__ */ m.jsx("div", { className: oe.body, children: l }) : null
        ] }),
        o ? /* @__PURE__ */ m.jsx(
          Dt,
          {
            className: oe.iconButton,
            ...h(y),
            children: $t(o) ? typeof o == "function" ? /* @__PURE__ */ m.jsx(o, { className: oe.icon }) : (
              // This element would have its props baked-in, if any;
              // it's the responsibility of the library user to style this one.
              o
            ) : /* @__PURE__ */ m.jsx(Ut, { className: oe.icon, icon: o })
          }
        ) : null
      ] })
    }
  );
}
ut.displayName = ct;
const On = te(
  ut
), nr = "_root_1128j_4", ar = "_header_1128j_4", sr = "_thumbnail_1128j_11", or = "_title_1128j_23", ir = "_subtitle_1128j_24", lr = "_anchor_1128j_25", cr = "_separator_1128j_49", ur = "_body_1128j_58", ne = {
  root: nr,
  header: ar,
  thumbnail: sr,
  title: or,
  subtitle: ir,
  anchor: lr,
  separator: cr,
  body: ur
}, ft = "AuthorCard";
function dt({
  authorTitle: a,
  authorSubtitle: l,
  authorHref: y,
  authorImage: u,
  // TODO CTA
  children: v,
  className: r,
  ...o
}, h) {
  return /* @__PURE__ */ m.jsx(
    ae,
    {
      variant: "bare",
      ref: h,
      className: Z(
        "airc-ui__" + Q(ft),
        ee(r)
      ),
      ...o,
      style: {
        ...o.style ? o.style : {},
        border: "1px solid var(--airc-ui__colors-grey-grey-100)"
      },
      children: /* @__PURE__ */ m.jsxs("div", { className: ne.root, children: [
        /* @__PURE__ */ m.jsxs("header", { className: ne.header, children: [
          u ? /* @__PURE__ */ m.jsx("figure", { className: ne.thumbnail, children: /* @__PURE__ */ m.jsx("img", { src: u, alt: `Immagine di ${a}` }) }) : null,
          /* @__PURE__ */ m.jsxs("div", { className: ne.meta, children: [
            a ? /* @__PURE__ */ m.jsx("span", { className: ne.title, children: a }) : null,
            l ? y ? /* @__PURE__ */ m.jsx(
              Le,
              {
                className: ne.anchor,
                href: y,
                rel: "noopener noreferrer",
                target: "_blank",
                children: l
              }
            ) : /* @__PURE__ */ m.jsx("span", { className: ne.subtitle, children: l }) : null
          ] })
        ] }),
        /* @__PURE__ */ m.jsx("hr", { className: ne.separator }),
        /* @__PURE__ */ m.jsx("div", { className: ne.body, children: v })
      ] })
    }
  );
}
dt.displayName = ft;
const Tn = te(
  dt
), fr = "_root_42fs2_4", dr = "_header_42fs2_4", pr = "_openingTitle_42fs2_8", hr = "_title_42fs2_15", yr = "_tagWrapper_42fs2_25", _r = "_tag_42fs2_25", vr = "_image_42fs2_37", ie = {
  root: fr,
  header: dr,
  openingTitle: pr,
  title: hr,
  tagWrapper: yr,
  tag: _r,
  image: vr
}, pt = "EditorialCard";
function ht({
  title: a,
  openingTitle: l,
  tags: y,
  image: u,
  className: v,
  ...r
}, o) {
  return /* @__PURE__ */ m.jsx(
    ae,
    {
      variant: "bare",
      ref: o,
      className: Z(
        "airc-ui__" + Q(pt),
        ee(v)
      ),
      ...r,
      style: {
        ...r.style ? r.style : {},
        borderRadius: "var(--airc-ui__radius-m)"
      },
      children: /* @__PURE__ */ m.jsxs("div", { className: ie.root, children: [
        /* @__PURE__ */ m.jsxs("header", { className: ie.header, children: [
          l ? /* @__PURE__ */ m.jsx(kt, { className: ie.openingTitle, children: l }) : null,
          a ? /* @__PURE__ */ m.jsx("h3", { className: ie.title, children: a }) : null,
          y != null && y.length ? /* @__PURE__ */ m.jsx("div", { className: ie.tagWrapper, children: y.map((h, d) => /* @__PURE__ */ m.jsx(
            Ht,
            {
              className: ie.tag,
              icon: h.icon,
              iconPosition: h.iconPosition,
              children: h.label
            },
            "Tag__" + d
          )) }) : null
        ] }),
        u ? /* @__PURE__ */ m.jsx("figure", { className: ie.image, children: /* @__PURE__ */ m.jsx("img", { src: u, alt: a }) }) : null
      ] })
    }
  );
}
ht.displayName = pt;
const Sn = te(
  ht
), mr = "_root_1vnve_26", br = "_container_1vnve_42", gr = "_indicator_1vnve_48", Pr = "_title_1vnve_66", Er = "_body_1vnve_78", ue = {
  root: mr,
  container: br,
  indicator: gr,
  title: Pr,
  body: Er
}, yt = "HighlightCard";
function _t({
  as: a,
  title: l,
  children: y,
  className: u,
  animate: v = !0,
  animationDelay: r = 0,
  style: o,
  ...h
}, d) {
  const O = a || "article", S = v ? it[O] : O, i = lt(h) ?? [], R = v ? {
    initial: { opacity: 0, scale: 0.95 },
    animate: { opacity: 1, scale: 1 },
    transition: { delay: r, duration: 0.2 }
  } : {};
  return /* @__PURE__ */ m.jsx(
    S,
    {
      ref: d,
      className: Z(
        "airc-ui__" + Q(yt),
        ue.root,
        ee(u),
        ...i
      ),
      ...o ? { style: o } : {},
      ...R,
      ...h,
      children: /* @__PURE__ */ m.jsxs("div", { className: ue.container, children: [
        /* @__PURE__ */ m.jsx("div", { className: ue.indicator, children: /* @__PURE__ */ m.jsx("span", {}) }),
        /* @__PURE__ */ m.jsxs("div", { className: ue.content, children: [
          l && /* @__PURE__ */ m.jsx("span", { className: ue.title, children: l }),
          /* @__PURE__ */ m.jsx("div", { className: ue.body, children: y })
        ] })
      ] })
    }
  );
}
_t.displayName = yt;
const wn = te(
  _t
), Or = "_root_1o3r8_4", Tr = "_header_1o3r8_4", Sr = "_chip_1o3r8_7", wr = "_title_1o3r8_10", Cr = "_content_1o3r8_20", Rr = "_body_1o3r8_23", Ar = "_cta_1o3r8_31", le = {
  root: Or,
  header: Tr,
  chip: Sr,
  title: wr,
  content: Cr,
  body: Rr,
  cta: Ar
}, vt = "IllustratedCard";
function mt({
  chip: a,
  title: l,
  image: y,
  cta: u,
  children: v,
  className: r,
  ...o
}, h) {
  return /* @__PURE__ */ m.jsx(
    ae,
    {
      variant: "bare",
      ref: h,
      className: Z(
        "airc-ui__" + Q(vt),
        ee(r)
      ),
      ...o,
      style: {
        ...o.style ? o.style : {},
        borderRadius: "var(--airc-ui__radius-m)",
        background: "linear-gradient(290deg, var(--airc-ui__colors-accent-500) 0%, var(--airc-ui__colors-accent-400) 100%)"
      },
      children: /* @__PURE__ */ m.jsxs("div", { className: le.root, children: [
        /* @__PURE__ */ m.jsxs("header", { className: le.header, children: [
          a ? /* @__PURE__ */ m.jsx(qt, { className: le.chip, children: a }) : null,
          l ? /* @__PURE__ */ m.jsx("h3", { className: le.title, children: l }) : null
        ] }),
        /* @__PURE__ */ m.jsxs(
          "div",
          {
            className: le.content,
            style: {
              background: `url("${y}") right bottom / contain no-repeat`,
              backgroundSize: "160px"
            },
            children: [
              /* @__PURE__ */ m.jsx("div", { className: le.body, children: v }),
              u != null && u.href && (u != null && u.label) ? /* @__PURE__ */ m.jsx(
                Le,
                {
                  variant: "white",
                  className: le.cta,
                  href: u.href,
                  target: u.target,
                  rel: u.rel,
                  children: u.label
                }
              ) : null
            ]
          }
        )
      ] })
    }
  );
}
mt.displayName = vt;
const Cn = te(
  mt
), xr = "_root_3b7nz_12", jr = "_image_3b7nz_17", Nr = "_overlay_3b7nz_24", Mr = "_content_3b7nz_30", Ir = "_title_3b7nz_45", Lr = "_body_3b7nz_51", Dr = "_cta_3b7nz_58", ce = {
  root: xr,
  image: jr,
  overlay: Nr,
  content: Mr,
  title: Ir,
  body: Lr,
  cta: Dr
}, bt = "ImageCard";
function gt({
  title: a,
  body: l,
  cta: y,
  image: u,
  ImageComponent: v = "img",
  className: r,
  ...o
}, h) {
  return /* @__PURE__ */ m.jsx(
    ae,
    {
      variant: "bare",
      ref: h,
      className: Z(
        "airc-ui__" + Q(bt),
        ee(r)
      ),
      ...o,
      style: {
        ...o.style ? o.style : {},
        borderRadius: "var(--airc-ui__radius-m)"
      },
      children: /* @__PURE__ */ m.jsxs("div", { className: ce.root, children: [
        /* @__PURE__ */ m.jsx(
          v,
          {
            src: u.url,
            alt: u.alternativeText || "Immagine di sfondo della card",
            className: ce.image,
            loading: "lazy"
          }
        ),
        /* @__PURE__ */ m.jsx("div", { className: ce.overlay, children: /* @__PURE__ */ m.jsxs("div", { className: ce.content, children: [
          a ? /* @__PURE__ */ m.jsx("span", { className: ce.title, children: a }) : null,
          l ? /* @__PURE__ */ m.jsx("p", { className: ce.body, children: l }) : null,
          y != null && y.href && (y != null && y.label) ? /* @__PURE__ */ m.jsx(
            Le,
            {
              variant: "white",
              className: ce.cta,
              href: y.href,
              target: y.target,
              rel: y.rel,
              children: y.label
            }
          ) : null
        ] }) })
      ] })
    }
  );
}
gt.displayName = bt;
const Rn = te(
  gt
), $r = "_root_b82ky_12", Ur = "_figures_b82ky_12", kr = "_figuresPart_b82ky_19", Hr = "_figuresWhole_b82ky_26", qr = "_figuresUnit_b82ky_29", Vr = "_progress_b82ky_32", Fr = "_ctaMessage_b82ky_40", se = {
  root: $r,
  figures: Ur,
  figuresPart: kr,
  figuresWhole: Hr,
  figuresUnit: qr,
  progress: Vr,
  ctaMessage: Fr
}, Pt = "ProgressCard", Br = /* @__PURE__ */ m.jsx(Ft, { variant: "embedded", numberOfAvatars: 3, label: "" });
function Et({
  figures: a,
  testimonials: l = Br,
  ctaMessage: y,
  className: u,
  ...v
}, r) {
  return /* @__PURE__ */ m.jsx(
    ae,
    {
      ref: r,
      className: Z(
        "airc-ui__" + Q(Pt),
        ee(u)
      ),
      ...v,
      children: /* @__PURE__ */ m.jsxs("div", { className: se.root, children: [
        a && /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
          /* @__PURE__ */ m.jsxs("div", { className: se.figures, children: [
            /* @__PURE__ */ m.jsx("span", { className: se.figuresPart, children: a.part }),
            /* @__PURE__ */ m.jsxs("span", { className: se.figuresWhole, children: [
              "/",
              a.whole
            ] }),
            /* @__PURE__ */ m.jsxs("span", { className: se.figuresUnit, children: [
              " ",
              a.unit,
              " raccolti"
            ] })
          ] }),
          /* @__PURE__ */ m.jsx(
            Vt,
            {
              className: se.progress,
              progress: { part: a.part, whole: a.whole }
            }
          )
        ] }),
        l && /* @__PURE__ */ m.jsx("div", { className: se.testimonials, children: l }),
        y && /* @__PURE__ */ m.jsx("div", { className: se.ctaMessage, children: y })
      ] })
    }
  );
}
Et.displayName = Pt;
const An = te(
  Et
), Wr = "_root_1o7vp_12", zr = "_container_1o7vp_28", Ue = {
  root: Wr,
  container: zr
}, Ot = "StickyCTA";
function Tt({
  children: a,
  hasBlur: l = !0,
  className: y,
  animate: u = !0,
  animationDelay: v = 0,
  style: r,
  ...o
}, h) {
  const d = Xt(() => Z(
    Ue.root,
    "airc-ui__" + Q(Ot),
    ee(y),
    ...lt(o) ?? []
  ), [y, o]), O = ({ children: S, ...i }) => u ? /* @__PURE__ */ m.jsx(
    it.div,
    {
      className: d,
      ref: h,
      ...i,
      ...r ? { style: r } : {},
      initial: { opacity: 0, y: 20 },
      animate: { opacity: 1, y: 0 },
      transition: { delay: v, duration: 0.3 },
      children: S
    }
  ) : /* @__PURE__ */ m.jsx(
    "div",
    {
      ref: h,
      className: d,
      ...i,
      ...r ? { style: r } : {},
      children: S
    }
  );
  return /* @__PURE__ */ m.jsx(O, { ...o, "data-blur": l, children: /* @__PURE__ */ m.jsx("div", { className: Ue.container, children: a }) });
}
Tt.displayName = Ot;
const xn = te(Tt), Yr = "_root_reo3l_4", Kr = "_callout_reo3l_8", ve = {
  root: Yr,
  callout: Kr
}, St = "TestimonialCard";
function wt({
  title: a,
  subtitle: l,
  image: y,
  altText: u,
  children: v,
  className: r,
  ...o
}, h) {
  return /* @__PURE__ */ m.jsx(
    ae,
    {
      variant: "bare",
      ref: h,
      className: Z(
        "airc-ui__" + Q(St),
        ee(r)
      ),
      ...o,
      children: /* @__PURE__ */ m.jsxs("div", { className: ve.root, children: [
        /* @__PURE__ */ m.jsx(
          Bt,
          {
            className: ve.testimonial,
            title: a,
            subtitle: l,
            image: y,
            altText: u,
            animate: !1
          }
        ),
        v ? /* @__PURE__ */ m.jsx(Wt, { className: ve.callout, children: v }) : null
      ] })
    }
  );
}
wt.displayName = St;
const jn = te(
  wt
), Xr = "_root_6cdd0_12", Jr = "_title_6cdd0_17", Gr = "_body_6cdd0_26", me = {
  root: Xr,
  title: Jr,
  body: Gr
}, Ct = "TextCard";
function Rt({ cardTitle: a, children: l, className: y, ...u }, v) {
  return /* @__PURE__ */ m.jsx(
    ae,
    {
      ref: v,
      className: Z(
        "airc-ui__" + Q(Ct),
        ee(y)
      ),
      ...u,
      style: {
        ...u.style ? u.style : {},
        borderRadius: "var(--airc-ui__radius-s)"
      },
      children: /* @__PURE__ */ m.jsxs("div", { className: me.root, children: [
        a && /* @__PURE__ */ m.jsx("span", { className: me.title, children: a }),
        /* @__PURE__ */ m.jsx("div", { className: me.body, children: l })
      ] })
    }
  );
}
Rt.displayName = Ct;
const Nn = te(Rt);
var be, ke;
function At() {
  if (ke) return be;
  ke = 1;
  var a = function(b) {
    return l(b) && !y(b);
  };
  function l(_) {
    return !!_ && typeof _ == "object";
  }
  function y(_) {
    var b = Object.prototype.toString.call(_);
    return b === "[object RegExp]" || b === "[object Date]" || r(_);
  }
  var u = typeof Symbol == "function" && Symbol.for, v = u ? Symbol.for("react.element") : 60103;
  function r(_) {
    return _.$$typeof === v;
  }
  function o(_) {
    return Array.isArray(_) ? [] : {};
  }
  function h(_, b) {
    return b.clone !== !1 && b.isMergeableObject(_) ? A(o(_), _, b) : _;
  }
  function d(_, b, p) {
    return _.concat(b).map(function(c) {
      return h(c, p);
    });
  }
  function O(_, b) {
    if (!b.customMerge)
      return A;
    var p = b.customMerge(_);
    return typeof p == "function" ? p : A;
  }
  function S(_) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(_).filter(function(b) {
      return Object.propertyIsEnumerable.call(_, b);
    }) : [];
  }
  function i(_) {
    return Object.keys(_).concat(S(_));
  }
  function R(_, b) {
    try {
      return b in _;
    } catch {
      return !1;
    }
  }
  function w(_, b) {
    return R(_, b) && !(Object.hasOwnProperty.call(_, b) && Object.propertyIsEnumerable.call(_, b));
  }
  function M(_, b, p) {
    var c = {};
    return p.isMergeableObject(_) && i(_).forEach(function(n) {
      c[n] = h(_[n], p);
    }), i(b).forEach(function(n) {
      w(_, n) || (R(_, n) && p.isMergeableObject(b[n]) ? c[n] = O(n, p)(_[n], b[n], p) : c[n] = h(b[n], p));
    }), c;
  }
  function A(_, b, p) {
    p = p || {}, p.arrayMerge = p.arrayMerge || d, p.isMergeableObject = p.isMergeableObject || a, p.cloneUnlessOtherwiseSpecified = h;
    var c = Array.isArray(b), n = Array.isArray(_), C = c === n;
    return C ? c ? p.arrayMerge(_, b, p) : M(_, b, p) : h(b, p);
  }
  A.all = function(b, p) {
    if (!Array.isArray(b))
      throw new Error("first argument should be an array");
    return b.reduce(function(c, n) {
      return A(c, n, p);
    }, {});
  };
  var $ = A;
  return be = $, be;
}
var He = Number.isNaN || function(l) {
  return typeof l == "number" && l !== l;
};
function Zr(a, l) {
  return !!(a === l || He(a) && He(l));
}
function Qr(a, l) {
  if (a.length !== l.length)
    return !1;
  for (var y = 0; y < a.length; y++)
    if (!Zr(a[y], l[y]))
      return !1;
  return !0;
}
function en(a, l) {
  l === void 0 && (l = Qr);
  var y, u = [], v, r = !1;
  function o() {
    for (var h = [], d = 0; d < arguments.length; d++)
      h[d] = arguments[d];
    return r && y === this && l(h, u) || (v = a.apply(this, h), r = !0, y = this, u = h), v;
  }
  return o;
}
const tn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: en
}, Symbol.toStringTag, { value: "Module" })), rn = /* @__PURE__ */ zt(tn);
var ge, qe;
function xt() {
  if (qe) return ge;
  qe = 1;
  var a = typeof Element < "u", l = typeof Map == "function", y = typeof Set == "function", u = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
  function v(r, o) {
    if (r === o) return !0;
    if (r && o && typeof r == "object" && typeof o == "object") {
      if (r.constructor !== o.constructor) return !1;
      var h, d, O;
      if (Array.isArray(r)) {
        if (h = r.length, h != o.length) return !1;
        for (d = h; d-- !== 0; )
          if (!v(r[d], o[d])) return !1;
        return !0;
      }
      var S;
      if (l && r instanceof Map && o instanceof Map) {
        if (r.size !== o.size) return !1;
        for (S = r.entries(); !(d = S.next()).done; )
          if (!o.has(d.value[0])) return !1;
        for (S = r.entries(); !(d = S.next()).done; )
          if (!v(d.value[1], o.get(d.value[0]))) return !1;
        return !0;
      }
      if (y && r instanceof Set && o instanceof Set) {
        if (r.size !== o.size) return !1;
        for (S = r.entries(); !(d = S.next()).done; )
          if (!o.has(d.value[0])) return !1;
        return !0;
      }
      if (u && ArrayBuffer.isView(r) && ArrayBuffer.isView(o)) {
        if (h = r.length, h != o.length) return !1;
        for (d = h; d-- !== 0; )
          if (r[d] !== o[d]) return !1;
        return !0;
      }
      if (r.constructor === RegExp) return r.source === o.source && r.flags === o.flags;
      if (r.valueOf !== Object.prototype.valueOf && typeof r.valueOf == "function" && typeof o.valueOf == "function") return r.valueOf() === o.valueOf();
      if (r.toString !== Object.prototype.toString && typeof r.toString == "function" && typeof o.toString == "function") return r.toString() === o.toString();
      if (O = Object.keys(r), h = O.length, h !== Object.keys(o).length) return !1;
      for (d = h; d-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(o, O[d])) return !1;
      if (a && r instanceof Element) return !1;
      for (d = h; d-- !== 0; )
        if (!((O[d] === "_owner" || O[d] === "__v" || O[d] === "__o") && r.$$typeof) && !v(r[O[d]], o[O[d]]))
          return !1;
      return !0;
    }
    return r !== r && o !== o;
  }
  return ge = function(o, h) {
    try {
      return v(o, h);
    } catch (d) {
      if ((d.message || "").match(/stack|recursion/i))
        return console.warn("react-fast-compare cannot handle circular refs"), !1;
      throw d;
    }
  }, ge;
}
var de = { exports: {} }, pe = { exports: {} }, Y = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ve;
function nn() {
  if (Ve) return Y;
  Ve = 1;
  var a = typeof Symbol == "function" && Symbol.for, l = a ? Symbol.for("react.element") : 60103, y = a ? Symbol.for("react.portal") : 60106, u = a ? Symbol.for("react.fragment") : 60107, v = a ? Symbol.for("react.strict_mode") : 60108, r = a ? Symbol.for("react.profiler") : 60114, o = a ? Symbol.for("react.provider") : 60109, h = a ? Symbol.for("react.context") : 60110, d = a ? Symbol.for("react.async_mode") : 60111, O = a ? Symbol.for("react.concurrent_mode") : 60111, S = a ? Symbol.for("react.forward_ref") : 60112, i = a ? Symbol.for("react.suspense") : 60113, R = a ? Symbol.for("react.suspense_list") : 60120, w = a ? Symbol.for("react.memo") : 60115, M = a ? Symbol.for("react.lazy") : 60116, A = a ? Symbol.for("react.block") : 60121, $ = a ? Symbol.for("react.fundamental") : 60117, _ = a ? Symbol.for("react.responder") : 60118, b = a ? Symbol.for("react.scope") : 60119;
  function p(n) {
    if (typeof n == "object" && n !== null) {
      var C = n.$$typeof;
      switch (C) {
        case l:
          switch (n = n.type, n) {
            case d:
            case O:
            case u:
            case r:
            case v:
            case i:
              return n;
            default:
              switch (n = n && n.$$typeof, n) {
                case h:
                case S:
                case M:
                case w:
                case o:
                  return n;
                default:
                  return C;
              }
          }
        case y:
          return C;
      }
    }
  }
  function c(n) {
    return p(n) === O;
  }
  return Y.AsyncMode = d, Y.ConcurrentMode = O, Y.ContextConsumer = h, Y.ContextProvider = o, Y.Element = l, Y.ForwardRef = S, Y.Fragment = u, Y.Lazy = M, Y.Memo = w, Y.Portal = y, Y.Profiler = r, Y.StrictMode = v, Y.Suspense = i, Y.isAsyncMode = function(n) {
    return c(n) || p(n) === d;
  }, Y.isConcurrentMode = c, Y.isContextConsumer = function(n) {
    return p(n) === h;
  }, Y.isContextProvider = function(n) {
    return p(n) === o;
  }, Y.isElement = function(n) {
    return typeof n == "object" && n !== null && n.$$typeof === l;
  }, Y.isForwardRef = function(n) {
    return p(n) === S;
  }, Y.isFragment = function(n) {
    return p(n) === u;
  }, Y.isLazy = function(n) {
    return p(n) === M;
  }, Y.isMemo = function(n) {
    return p(n) === w;
  }, Y.isPortal = function(n) {
    return p(n) === y;
  }, Y.isProfiler = function(n) {
    return p(n) === r;
  }, Y.isStrictMode = function(n) {
    return p(n) === v;
  }, Y.isSuspense = function(n) {
    return p(n) === i;
  }, Y.isValidElementType = function(n) {
    return typeof n == "string" || typeof n == "function" || n === u || n === O || n === r || n === v || n === i || n === R || typeof n == "object" && n !== null && (n.$$typeof === M || n.$$typeof === w || n.$$typeof === o || n.$$typeof === h || n.$$typeof === S || n.$$typeof === $ || n.$$typeof === _ || n.$$typeof === b || n.$$typeof === A);
  }, Y.typeOf = p, Y;
}
var K = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Fe;
function an() {
  return Fe || (Fe = 1, process.env.NODE_ENV !== "production" && function() {
    var a = typeof Symbol == "function" && Symbol.for, l = a ? Symbol.for("react.element") : 60103, y = a ? Symbol.for("react.portal") : 60106, u = a ? Symbol.for("react.fragment") : 60107, v = a ? Symbol.for("react.strict_mode") : 60108, r = a ? Symbol.for("react.profiler") : 60114, o = a ? Symbol.for("react.provider") : 60109, h = a ? Symbol.for("react.context") : 60110, d = a ? Symbol.for("react.async_mode") : 60111, O = a ? Symbol.for("react.concurrent_mode") : 60111, S = a ? Symbol.for("react.forward_ref") : 60112, i = a ? Symbol.for("react.suspense") : 60113, R = a ? Symbol.for("react.suspense_list") : 60120, w = a ? Symbol.for("react.memo") : 60115, M = a ? Symbol.for("react.lazy") : 60116, A = a ? Symbol.for("react.block") : 60121, $ = a ? Symbol.for("react.fundamental") : 60117, _ = a ? Symbol.for("react.responder") : 60118, b = a ? Symbol.for("react.scope") : 60119;
    function p(E) {
      return typeof E == "string" || typeof E == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      E === u || E === O || E === r || E === v || E === i || E === R || typeof E == "object" && E !== null && (E.$$typeof === M || E.$$typeof === w || E.$$typeof === o || E.$$typeof === h || E.$$typeof === S || E.$$typeof === $ || E.$$typeof === _ || E.$$typeof === b || E.$$typeof === A);
    }
    function c(E) {
      if (typeof E == "object" && E !== null) {
        var re = E.$$typeof;
        switch (re) {
          case l:
            var fe = E.type;
            switch (fe) {
              case d:
              case O:
              case u:
              case r:
              case v:
              case i:
                return fe;
              default:
                var $e = fe && fe.$$typeof;
                switch ($e) {
                  case h:
                  case S:
                  case M:
                  case w:
                  case o:
                    return $e;
                  default:
                    return re;
                }
            }
          case y:
            return re;
        }
      }
    }
    var n = d, C = O, U = h, B = o, W = l, X = S, N = u, I = M, k = w, s = y, e = r, g = v, z = i, J = !1;
    function P(E) {
      return J || (J = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), t(E) || c(E) === d;
    }
    function t(E) {
      return c(E) === O;
    }
    function f(E) {
      return c(E) === h;
    }
    function T(E) {
      return c(E) === o;
    }
    function x(E) {
      return typeof E == "object" && E !== null && E.$$typeof === l;
    }
    function j(E) {
      return c(E) === S;
    }
    function H(E) {
      return c(E) === u;
    }
    function L(E) {
      return c(E) === M;
    }
    function D(E) {
      return c(E) === w;
    }
    function F(E) {
      return c(E) === y;
    }
    function q(E) {
      return c(E) === r;
    }
    function V(E) {
      return c(E) === v;
    }
    function G(E) {
      return c(E) === i;
    }
    K.AsyncMode = n, K.ConcurrentMode = C, K.ContextConsumer = U, K.ContextProvider = B, K.Element = W, K.ForwardRef = X, K.Fragment = N, K.Lazy = I, K.Memo = k, K.Portal = s, K.Profiler = e, K.StrictMode = g, K.Suspense = z, K.isAsyncMode = P, K.isConcurrentMode = t, K.isContextConsumer = f, K.isContextProvider = T, K.isElement = x, K.isForwardRef = j, K.isFragment = H, K.isLazy = L, K.isMemo = D, K.isPortal = F, K.isProfiler = q, K.isStrictMode = V, K.isSuspense = G, K.isValidElementType = p, K.typeOf = c;
  }()), K;
}
var Be;
function jt() {
  return Be || (Be = 1, process.env.NODE_ENV === "production" ? pe.exports = nn() : pe.exports = an()), pe.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Pe, We;
function sn() {
  if (We) return Pe;
  We = 1;
  var a = Object.getOwnPropertySymbols, l = Object.prototype.hasOwnProperty, y = Object.prototype.propertyIsEnumerable;
  function u(r) {
    if (r == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(r);
  }
  function v() {
    try {
      if (!Object.assign)
        return !1;
      var r = new String("abc");
      if (r[5] = "de", Object.getOwnPropertyNames(r)[0] === "5")
        return !1;
      for (var o = {}, h = 0; h < 10; h++)
        o["_" + String.fromCharCode(h)] = h;
      var d = Object.getOwnPropertyNames(o).map(function(S) {
        return o[S];
      });
      if (d.join("") !== "0123456789")
        return !1;
      var O = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(S) {
        O[S] = S;
      }), Object.keys(Object.assign({}, O)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Pe = v() ? Object.assign : function(r, o) {
    for (var h, d = u(r), O, S = 1; S < arguments.length; S++) {
      h = Object(arguments[S]);
      for (var i in h)
        l.call(h, i) && (d[i] = h[i]);
      if (a) {
        O = a(h);
        for (var R = 0; R < O.length; R++)
          y.call(h, O[R]) && (d[O[R]] = h[O[R]]);
      }
    }
    return d;
  }, Pe;
}
var Ee, ze;
function De() {
  if (ze) return Ee;
  ze = 1;
  var a = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Ee = a, Ee;
}
var Oe, Ye;
function Nt() {
  return Ye || (Ye = 1, Oe = Function.call.bind(Object.prototype.hasOwnProperty)), Oe;
}
var Te, Ke;
function on() {
  if (Ke) return Te;
  Ke = 1;
  var a = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var l = /* @__PURE__ */ De(), y = {}, u = /* @__PURE__ */ Nt();
    a = function(r) {
      var o = "Warning: " + r;
      typeof console < "u" && console.error(o);
      try {
        throw new Error(o);
      } catch {
      }
    };
  }
  function v(r, o, h, d, O) {
    if (process.env.NODE_ENV !== "production") {
      for (var S in r)
        if (u(r, S)) {
          var i;
          try {
            if (typeof r[S] != "function") {
              var R = Error(
                (d || "React class") + ": " + h + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw R.name = "Invariant Violation", R;
            }
            i = r[S](o, S, d, h, null, l);
          } catch (M) {
            i = M;
          }
          if (i && !(i instanceof Error) && a(
            (d || "React class") + ": type specification of " + h + " `" + S + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof i + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), i instanceof Error && !(i.message in y)) {
            y[i.message] = !0;
            var w = O ? O() : "";
            a(
              "Failed " + h + " type: " + i.message + (w ?? "")
            );
          }
        }
    }
  }
  return v.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (y = {});
  }, Te = v, Te;
}
var Se, Xe;
function ln() {
  if (Xe) return Se;
  Xe = 1;
  var a = jt(), l = sn(), y = /* @__PURE__ */ De(), u = /* @__PURE__ */ Nt(), v = /* @__PURE__ */ on(), r = function() {
  };
  process.env.NODE_ENV !== "production" && (r = function(h) {
    var d = "Warning: " + h;
    typeof console < "u" && console.error(d);
    try {
      throw new Error(d);
    } catch {
    }
  });
  function o() {
    return null;
  }
  return Se = function(h, d) {
    var O = typeof Symbol == "function" && Symbol.iterator, S = "@@iterator";
    function i(t) {
      var f = t && (O && t[O] || t[S]);
      if (typeof f == "function")
        return f;
    }
    var R = "<<anonymous>>", w = {
      array: _("array"),
      bigint: _("bigint"),
      bool: _("boolean"),
      func: _("function"),
      number: _("number"),
      object: _("object"),
      string: _("string"),
      symbol: _("symbol"),
      any: b(),
      arrayOf: p,
      element: c(),
      elementType: n(),
      instanceOf: C,
      node: X(),
      objectOf: B,
      oneOf: U,
      oneOfType: W,
      shape: I,
      exact: k
    };
    function M(t, f) {
      return t === f ? t !== 0 || 1 / t === 1 / f : t !== t && f !== f;
    }
    function A(t, f) {
      this.message = t, this.data = f && typeof f == "object" ? f : {}, this.stack = "";
    }
    A.prototype = Error.prototype;
    function $(t) {
      if (process.env.NODE_ENV !== "production")
        var f = {}, T = 0;
      function x(H, L, D, F, q, V, G) {
        if (F = F || R, V = V || D, G !== y) {
          if (d) {
            var E = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw E.name = "Invariant Violation", E;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var re = F + ":" + D;
            !f[re] && // Avoid spamming the console because they are often not actionable except for lib authors
            T < 3 && (r(
              "You are manually calling a React.PropTypes validation function for the `" + V + "` prop on `" + F + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), f[re] = !0, T++);
          }
        }
        return L[D] == null ? H ? L[D] === null ? new A("The " + q + " `" + V + "` is marked as required " + ("in `" + F + "`, but its value is `null`.")) : new A("The " + q + " `" + V + "` is marked as required in " + ("`" + F + "`, but its value is `undefined`.")) : null : t(L, D, F, q, V);
      }
      var j = x.bind(null, !1);
      return j.isRequired = x.bind(null, !0), j;
    }
    function _(t) {
      function f(T, x, j, H, L, D) {
        var F = T[x], q = g(F);
        if (q !== t) {
          var V = z(F);
          return new A(
            "Invalid " + H + " `" + L + "` of type " + ("`" + V + "` supplied to `" + j + "`, expected ") + ("`" + t + "`."),
            { expectedType: t }
          );
        }
        return null;
      }
      return $(f);
    }
    function b() {
      return $(o);
    }
    function p(t) {
      function f(T, x, j, H, L) {
        if (typeof t != "function")
          return new A("Property `" + L + "` of component `" + j + "` has invalid PropType notation inside arrayOf.");
        var D = T[x];
        if (!Array.isArray(D)) {
          var F = g(D);
          return new A("Invalid " + H + " `" + L + "` of type " + ("`" + F + "` supplied to `" + j + "`, expected an array."));
        }
        for (var q = 0; q < D.length; q++) {
          var V = t(D, q, j, H, L + "[" + q + "]", y);
          if (V instanceof Error)
            return V;
        }
        return null;
      }
      return $(f);
    }
    function c() {
      function t(f, T, x, j, H) {
        var L = f[T];
        if (!h(L)) {
          var D = g(L);
          return new A("Invalid " + j + " `" + H + "` of type " + ("`" + D + "` supplied to `" + x + "`, expected a single ReactElement."));
        }
        return null;
      }
      return $(t);
    }
    function n() {
      function t(f, T, x, j, H) {
        var L = f[T];
        if (!a.isValidElementType(L)) {
          var D = g(L);
          return new A("Invalid " + j + " `" + H + "` of type " + ("`" + D + "` supplied to `" + x + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return $(t);
    }
    function C(t) {
      function f(T, x, j, H, L) {
        if (!(T[x] instanceof t)) {
          var D = t.name || R, F = P(T[x]);
          return new A("Invalid " + H + " `" + L + "` of type " + ("`" + F + "` supplied to `" + j + "`, expected ") + ("instance of `" + D + "`."));
        }
        return null;
      }
      return $(f);
    }
    function U(t) {
      if (!Array.isArray(t))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? r(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : r("Invalid argument supplied to oneOf, expected an array.")), o;
      function f(T, x, j, H, L) {
        for (var D = T[x], F = 0; F < t.length; F++)
          if (M(D, t[F]))
            return null;
        var q = JSON.stringify(t, function(G, E) {
          var re = z(E);
          return re === "symbol" ? String(E) : E;
        });
        return new A("Invalid " + H + " `" + L + "` of value `" + String(D) + "` " + ("supplied to `" + j + "`, expected one of " + q + "."));
      }
      return $(f);
    }
    function B(t) {
      function f(T, x, j, H, L) {
        if (typeof t != "function")
          return new A("Property `" + L + "` of component `" + j + "` has invalid PropType notation inside objectOf.");
        var D = T[x], F = g(D);
        if (F !== "object")
          return new A("Invalid " + H + " `" + L + "` of type " + ("`" + F + "` supplied to `" + j + "`, expected an object."));
        for (var q in D)
          if (u(D, q)) {
            var V = t(D, q, j, H, L + "." + q, y);
            if (V instanceof Error)
              return V;
          }
        return null;
      }
      return $(f);
    }
    function W(t) {
      if (!Array.isArray(t))
        return process.env.NODE_ENV !== "production" && r("Invalid argument supplied to oneOfType, expected an instance of array."), o;
      for (var f = 0; f < t.length; f++) {
        var T = t[f];
        if (typeof T != "function")
          return r(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + J(T) + " at index " + f + "."
          ), o;
      }
      function x(j, H, L, D, F) {
        for (var q = [], V = 0; V < t.length; V++) {
          var G = t[V], E = G(j, H, L, D, F, y);
          if (E == null)
            return null;
          E.data && u(E.data, "expectedType") && q.push(E.data.expectedType);
        }
        var re = q.length > 0 ? ", expected one of type [" + q.join(", ") + "]" : "";
        return new A("Invalid " + D + " `" + F + "` supplied to " + ("`" + L + "`" + re + "."));
      }
      return $(x);
    }
    function X() {
      function t(f, T, x, j, H) {
        return s(f[T]) ? null : new A("Invalid " + j + " `" + H + "` supplied to " + ("`" + x + "`, expected a ReactNode."));
      }
      return $(t);
    }
    function N(t, f, T, x, j) {
      return new A(
        (t || "React class") + ": " + f + " type `" + T + "." + x + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + j + "`."
      );
    }
    function I(t) {
      function f(T, x, j, H, L) {
        var D = T[x], F = g(D);
        if (F !== "object")
          return new A("Invalid " + H + " `" + L + "` of type `" + F + "` " + ("supplied to `" + j + "`, expected `object`."));
        for (var q in t) {
          var V = t[q];
          if (typeof V != "function")
            return N(j, H, L, q, z(V));
          var G = V(D, q, j, H, L + "." + q, y);
          if (G)
            return G;
        }
        return null;
      }
      return $(f);
    }
    function k(t) {
      function f(T, x, j, H, L) {
        var D = T[x], F = g(D);
        if (F !== "object")
          return new A("Invalid " + H + " `" + L + "` of type `" + F + "` " + ("supplied to `" + j + "`, expected `object`."));
        var q = l({}, T[x], t);
        for (var V in q) {
          var G = t[V];
          if (u(t, V) && typeof G != "function")
            return N(j, H, L, V, z(G));
          if (!G)
            return new A(
              "Invalid " + H + " `" + L + "` key `" + V + "` supplied to `" + j + "`.\nBad object: " + JSON.stringify(T[x], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(t), null, "  ")
            );
          var E = G(D, V, j, H, L + "." + V, y);
          if (E)
            return E;
        }
        return null;
      }
      return $(f);
    }
    function s(t) {
      switch (typeof t) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !t;
        case "object":
          if (Array.isArray(t))
            return t.every(s);
          if (t === null || h(t))
            return !0;
          var f = i(t);
          if (f) {
            var T = f.call(t), x;
            if (f !== t.entries) {
              for (; !(x = T.next()).done; )
                if (!s(x.value))
                  return !1;
            } else
              for (; !(x = T.next()).done; ) {
                var j = x.value;
                if (j && !s(j[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function e(t, f) {
      return t === "symbol" ? !0 : f ? f["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && f instanceof Symbol : !1;
    }
    function g(t) {
      var f = typeof t;
      return Array.isArray(t) ? "array" : t instanceof RegExp ? "object" : e(f, t) ? "symbol" : f;
    }
    function z(t) {
      if (typeof t > "u" || t === null)
        return "" + t;
      var f = g(t);
      if (f === "object") {
        if (t instanceof Date)
          return "date";
        if (t instanceof RegExp)
          return "regexp";
      }
      return f;
    }
    function J(t) {
      var f = z(t);
      switch (f) {
        case "array":
        case "object":
          return "an " + f;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + f;
        default:
          return f;
      }
    }
    function P(t) {
      return !t.constructor || !t.constructor.name ? R : t.constructor.name;
    }
    return w.checkPropTypes = v, w.resetWarningCache = v.resetWarningCache, w.PropTypes = w, w;
  }, Se;
}
var we, Je;
function cn() {
  if (Je) return we;
  Je = 1;
  var a = /* @__PURE__ */ De();
  function l() {
  }
  function y() {
  }
  return y.resetWarningCache = l, we = function() {
    function u(o, h, d, O, S, i) {
      if (i !== a) {
        var R = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw R.name = "Invariant Violation", R;
      }
    }
    u.isRequired = u;
    function v() {
      return u;
    }
    var r = {
      array: u,
      bigint: u,
      bool: u,
      func: u,
      number: u,
      object: u,
      string: u,
      symbol: u,
      any: u,
      arrayOf: v,
      element: u,
      elementType: u,
      instanceOf: v,
      node: u,
      objectOf: v,
      oneOf: v,
      oneOfType: v,
      shape: v,
      exact: v,
      checkPropTypes: y,
      resetWarningCache: l
    };
    return r.PropTypes = r, r;
  }, we;
}
var Ge;
function un() {
  if (Ge) return de.exports;
  if (Ge = 1, process.env.NODE_ENV !== "production") {
    var a = jt(), l = !0;
    de.exports = /* @__PURE__ */ ln()(a.isElement, l);
  } else
    de.exports = /* @__PURE__ */ cn()();
  return de.exports;
}
var Ce, Ze;
function Mt() {
  if (Ze) return Ce;
  Ze = 1;
  var a = Object.create, l = Object.defineProperty, y = Object.getOwnPropertyDescriptor, u = Object.getOwnPropertyNames, v = Object.getPrototypeOf, r = Object.prototype.hasOwnProperty, o = (B, W) => {
    for (var X in W)
      l(B, X, { get: W[X], enumerable: !0 });
  }, h = (B, W, X, N) => {
    if (W && typeof W == "object" || typeof W == "function")
      for (let I of u(W))
        !r.call(B, I) && I !== X && l(B, I, { get: () => W[I], enumerable: !(N = y(W, I)) || N.enumerable });
    return B;
  }, d = (B, W, X) => (X = B != null ? a(v(B)) : {}, h(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    !B || !B.__esModule ? l(X, "default", { value: B, enumerable: !0 }) : X,
    B
  )), O = (B) => h(l({}, "__esModule", { value: !0 }), B), S = {};
  o(S, {
    defaultProps: () => U,
    propTypes: () => n
  }), Ce = O(S);
  var i = d(/* @__PURE__ */ un());
  const { string: R, bool: w, number: M, array: A, oneOfType: $, shape: _, object: b, func: p, node: c } = i.default, n = {
    url: $([R, A, b]),
    playing: w,
    loop: w,
    controls: w,
    volume: M,
    muted: w,
    playbackRate: M,
    width: $([R, M]),
    height: $([R, M]),
    style: b,
    progressInterval: M,
    playsinline: w,
    pip: w,
    stopOnUnmount: w,
    light: $([w, R, b]),
    playIcon: c,
    previewTabIndex: M,
    previewAriaLabel: R,
    fallback: c,
    oEmbedUrl: R,
    wrapper: $([
      R,
      p,
      _({ render: p.isRequired })
    ]),
    config: _({
      soundcloud: _({
        options: b
      }),
      youtube: _({
        playerVars: b,
        embedOptions: b,
        onUnstarted: p
      }),
      facebook: _({
        appId: R,
        version: R,
        playerId: R,
        attributes: b
      }),
      dailymotion: _({
        params: b
      }),
      vimeo: _({
        playerOptions: b,
        title: R
      }),
      mux: _({
        attributes: b,
        version: R
      }),
      file: _({
        attributes: b,
        tracks: A,
        forceVideo: w,
        forceAudio: w,
        forceHLS: w,
        forceSafariHLS: w,
        forceDisableHls: w,
        forceDASH: w,
        forceFLV: w,
        hlsOptions: b,
        hlsVersion: R,
        dashVersion: R,
        flvVersion: R
      }),
      wistia: _({
        options: b,
        playerId: R,
        customControls: A
      }),
      mixcloud: _({
        options: b
      }),
      twitch: _({
        options: b,
        playerId: R
      }),
      vidyard: _({
        options: b
      })
    }),
    onReady: p,
    onStart: p,
    onPlay: p,
    onPause: p,
    onBuffer: p,
    onBufferEnd: p,
    onEnded: p,
    onError: p,
    onDuration: p,
    onSeek: p,
    onPlaybackRateChange: p,
    onPlaybackQualityChange: p,
    onProgress: p,
    onClickPreview: p,
    onEnablePIP: p,
    onDisablePIP: p
  }, C = () => {
  }, U = {
    playing: !1,
    loop: !1,
    controls: !1,
    volume: null,
    muted: !1,
    playbackRate: 1,
    width: "640px",
    height: "360px",
    style: {},
    progressInterval: 1e3,
    playsinline: !1,
    pip: !1,
    stopOnUnmount: !0,
    light: !1,
    fallback: null,
    wrapper: "div",
    previewTabIndex: 0,
    previewAriaLabel: "",
    oEmbedUrl: "https://noembed.com/embed?url={url}",
    config: {
      soundcloud: {
        options: {
          visual: !0,
          // Undocumented, but makes player fill container and look better
          buying: !1,
          liking: !1,
          download: !1,
          sharing: !1,
          show_comments: !1,
          show_playcount: !1
        }
      },
      youtube: {
        playerVars: {
          playsinline: 1,
          showinfo: 0,
          rel: 0,
          iv_load_policy: 3,
          modestbranding: 1
        },
        embedOptions: {},
        onUnstarted: C
      },
      facebook: {
        appId: "1309697205772819",
        version: "v3.3",
        playerId: null,
        attributes: {}
      },
      dailymotion: {
        params: {
          api: 1,
          "endscreen-enable": !1
        }
      },
      vimeo: {
        playerOptions: {
          autopause: !1,
          byline: !1,
          portrait: !1,
          title: !1
        },
        title: null
      },
      mux: {
        attributes: {},
        version: "2"
      },
      file: {
        attributes: {},
        tracks: [],
        forceVideo: !1,
        forceAudio: !1,
        forceHLS: !1,
        forceDASH: !1,
        forceFLV: !1,
        hlsOptions: {},
        hlsVersion: "1.1.4",
        dashVersion: "3.1.3",
        flvVersion: "1.5.0",
        forceDisableHls: !1
      },
      wistia: {
        options: {},
        playerId: null,
        customControls: null
      },
      mixcloud: {
        options: {
          hide_cover: 1
        }
      },
      twitch: {
        options: {},
        playerId: null
      },
      vidyard: {
        options: {}
      }
    },
    onReady: C,
    onStart: C,
    onPlay: C,
    onPause: C,
    onBuffer: C,
    onBufferEnd: C,
    onEnded: C,
    onError: C,
    onDuration: C,
    onSeek: C,
    onPlaybackRateChange: C,
    onPlaybackQualityChange: C,
    onProgress: C,
    onClickPreview: C,
    onEnablePIP: C,
    onDisablePIP: C
  };
  return Ce;
}
var Re, Qe;
function fn() {
  if (Qe) return Re;
  Qe = 1, Re = function(v, r, o) {
    var h = document.head || document.getElementsByTagName("head")[0], d = document.createElement("script");
    typeof r == "function" && (o = r, r = {}), r = r || {}, o = o || function() {
    }, d.type = r.type || "text/javascript", d.charset = r.charset || "utf8", d.async = "async" in r ? !!r.async : !0, d.src = v, r.attrs && a(d, r.attrs), r.text && (d.text = "" + r.text);
    var O = "onload" in d ? l : y;
    O(d, o), d.onload || l(d, o), h.appendChild(d);
  };
  function a(u, v) {
    for (var r in v)
      u.setAttribute(r, v[r]);
  }
  function l(u, v) {
    u.onload = function() {
      this.onerror = this.onload = null, v(null, u);
    }, u.onerror = function() {
      this.onerror = this.onload = null, v(new Error("Failed to load " + this.src), u);
    };
  }
  function y(u, v) {
    u.onreadystatechange = function() {
      this.readyState != "complete" && this.readyState != "loaded" || (this.onreadystatechange = null, v(null, u));
    };
  }
  return Re;
}
var Ae, et;
function ye() {
  if (et) return Ae;
  et = 1;
  var a = Object.create, l = Object.defineProperty, y = Object.getOwnPropertyDescriptor, u = Object.getOwnPropertyNames, v = Object.getPrototypeOf, r = Object.prototype.hasOwnProperty, o = (P, t) => {
    for (var f in t)
      l(P, f, { get: t[f], enumerable: !0 });
  }, h = (P, t, f, T) => {
    if (t && typeof t == "object" || typeof t == "function")
      for (let x of u(t))
        !r.call(P, x) && x !== f && l(P, x, { get: () => t[x], enumerable: !(T = y(t, x)) || T.enumerable });
    return P;
  }, d = (P, t, f) => (f = P != null ? a(v(P)) : {}, h(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    !P || !P.__esModule ? l(f, "default", { value: P, enumerable: !0 }) : f,
    P
  )), O = (P) => h(l({}, "__esModule", { value: !0 }), P), S = {};
  o(S, {
    callPlayer: () => s,
    getConfig: () => I,
    getSDK: () => N,
    isBlobUrl: () => g,
    isMediaStream: () => e,
    lazy: () => M,
    omit: () => k,
    parseEndTime: () => C,
    parseStartTime: () => n,
    queryString: () => B,
    randomString: () => U,
    supportsWebKitPresentationMode: () => z
  }), Ae = O(S);
  var i = d(he), R = d(fn()), w = d(At());
  const M = (P) => i.default.lazy(async () => {
    const t = await P();
    return typeof t.default == "function" ? t : t.default;
  }), A = /[?&#](?:start|t)=([0-9hms]+)/, $ = /[?&#]end=([0-9hms]+)/, _ = /(\d+)(h|m|s)/g, b = /^\d+$/;
  function p(P, t) {
    if (P instanceof Array)
      return;
    const f = P.match(t);
    if (f) {
      const T = f[1];
      if (T.match(_))
        return c(T);
      if (b.test(T))
        return parseInt(T);
    }
  }
  function c(P) {
    let t = 0, f = _.exec(P);
    for (; f !== null; ) {
      const [, T, x] = f;
      x === "h" && (t += parseInt(T, 10) * 60 * 60), x === "m" && (t += parseInt(T, 10) * 60), x === "s" && (t += parseInt(T, 10)), f = _.exec(P);
    }
    return t;
  }
  function n(P) {
    return p(P, A);
  }
  function C(P) {
    return p(P, $);
  }
  function U() {
    return Math.random().toString(36).substr(2, 5);
  }
  function B(P) {
    return Object.keys(P).map((t) => `${t}=${P[t]}`).join("&");
  }
  function W(P) {
    return window[P] ? window[P] : window.exports && window.exports[P] ? window.exports[P] : window.module && window.module.exports && window.module.exports[P] ? window.module.exports[P] : null;
  }
  const X = {}, N = function(t, f, T = null, x = () => !0, j = R.default) {
    const H = W(f);
    return H && x(H) ? Promise.resolve(H) : new Promise((L, D) => {
      if (X[t]) {
        X[t].push({ resolve: L, reject: D });
        return;
      }
      X[t] = [{ resolve: L, reject: D }];
      const F = (q) => {
        X[t].forEach((V) => V.resolve(q));
      };
      if (T) {
        const q = window[T];
        window[T] = function() {
          q && q(), F(W(f));
        };
      }
      j(t, (q) => {
        q ? (X[t].forEach((V) => V.reject(q)), X[t] = null) : T || F(W(f));
      });
    });
  };
  function I(P, t) {
    return (0, w.default)(t.config, P.config);
  }
  function k(P, ...t) {
    const f = [].concat(...t), T = {}, x = Object.keys(P);
    for (const j of x)
      f.indexOf(j) === -1 && (T[j] = P[j]);
    return T;
  }
  function s(P, ...t) {
    if (!this.player || !this.player[P]) {
      let f = `ReactPlayer: ${this.constructor.displayName} player could not call %c${P}%c – `;
      return this.player ? this.player[P] || (f += "The method was not available") : f += "The player was not available", console.warn(f, "font-weight: bold", ""), null;
    }
    return this.player[P](...t);
  }
  function e(P) {
    return typeof window < "u" && typeof window.MediaStream < "u" && P instanceof window.MediaStream;
  }
  function g(P) {
    return /^blob:/.test(P);
  }
  function z(P = document.createElement("video")) {
    const t = /iPhone|iPod/.test(navigator.userAgent) === !1;
    return P.webkitSupportsPresentationMode && typeof P.webkitSetPresentationMode == "function" && t;
  }
  function J(P) {
    return P;
  }
  return Ae;
}
var xe, tt;
function dn() {
  if (tt) return xe;
  tt = 1;
  var a = Object.create, l = Object.defineProperty, y = Object.getOwnPropertyDescriptor, u = Object.getOwnPropertyNames, v = Object.getPrototypeOf, r = Object.prototype.hasOwnProperty, o = (p, c, n) => c in p ? l(p, c, { enumerable: !0, configurable: !0, writable: !0, value: n }) : p[c] = n, h = (p, c) => {
    for (var n in c)
      l(p, n, { get: c[n], enumerable: !0 });
  }, d = (p, c, n, C) => {
    if (c && typeof c == "object" || typeof c == "function")
      for (let U of u(c))
        !r.call(p, U) && U !== n && l(p, U, { get: () => c[U], enumerable: !(C = y(c, U)) || C.enumerable });
    return p;
  }, O = (p, c, n) => (n = p != null ? a(v(p)) : {}, d(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    !p || !p.__esModule ? l(n, "default", { value: p, enumerable: !0 }) : n,
    p
  )), S = (p) => d(l({}, "__esModule", { value: !0 }), p), i = (p, c, n) => (o(p, typeof c != "symbol" ? c + "" : c, n), n), R = {};
  h(R, {
    default: () => b
  }), xe = S(R);
  var w = O(he), M = O(xt()), A = /* @__PURE__ */ Mt(), $ = /* @__PURE__ */ ye();
  const _ = 5e3;
  class b extends w.Component {
    constructor() {
      super(...arguments), i(this, "mounted", !1), i(this, "isReady", !1), i(this, "isPlaying", !1), i(this, "isLoading", !0), i(this, "loadOnReady", null), i(this, "startOnPlay", !0), i(this, "seekOnPlay", null), i(this, "onDurationCalled", !1), i(this, "handlePlayerMount", (c) => {
        if (this.player) {
          this.progress();
          return;
        }
        this.player = c, this.player.load(this.props.url), this.progress();
      }), i(this, "getInternalPlayer", (c) => this.player ? this.player[c] : null), i(this, "progress", () => {
        if (this.props.url && this.player && this.isReady) {
          const c = this.getCurrentTime() || 0, n = this.getSecondsLoaded(), C = this.getDuration();
          if (C) {
            const U = {
              playedSeconds: c,
              played: c / C
            };
            n !== null && (U.loadedSeconds = n, U.loaded = n / C), (U.playedSeconds !== this.prevPlayed || U.loadedSeconds !== this.prevLoaded) && this.props.onProgress(U), this.prevPlayed = U.playedSeconds, this.prevLoaded = U.loadedSeconds;
          }
        }
        this.progressTimeout = setTimeout(this.progress, this.props.progressFrequency || this.props.progressInterval);
      }), i(this, "handleReady", () => {
        if (!this.mounted)
          return;
        this.isReady = !0, this.isLoading = !1;
        const { onReady: c, playing: n, volume: C, muted: U } = this.props;
        c(), !U && C !== null && this.player.setVolume(C), this.loadOnReady ? (this.player.load(this.loadOnReady, !0), this.loadOnReady = null) : n && this.player.play(), this.handleDurationCheck();
      }), i(this, "handlePlay", () => {
        this.isPlaying = !0, this.isLoading = !1;
        const { onStart: c, onPlay: n, playbackRate: C } = this.props;
        this.startOnPlay && (this.player.setPlaybackRate && C !== 1 && this.player.setPlaybackRate(C), c(), this.startOnPlay = !1), n(), this.seekOnPlay && (this.seekTo(this.seekOnPlay), this.seekOnPlay = null), this.handleDurationCheck();
      }), i(this, "handlePause", (c) => {
        this.isPlaying = !1, this.isLoading || this.props.onPause(c);
      }), i(this, "handleEnded", () => {
        const { activePlayer: c, loop: n, onEnded: C } = this.props;
        c.loopOnEnded && n && this.seekTo(0), n || (this.isPlaying = !1, C());
      }), i(this, "handleError", (...c) => {
        this.isLoading = !1, this.props.onError(...c);
      }), i(this, "handleDurationCheck", () => {
        clearTimeout(this.durationCheckTimeout);
        const c = this.getDuration();
        c ? this.onDurationCalled || (this.props.onDuration(c), this.onDurationCalled = !0) : this.durationCheckTimeout = setTimeout(this.handleDurationCheck, 100);
      }), i(this, "handleLoaded", () => {
        this.isLoading = !1;
      });
    }
    componentDidMount() {
      this.mounted = !0;
    }
    componentWillUnmount() {
      clearTimeout(this.progressTimeout), clearTimeout(this.durationCheckTimeout), this.isReady && this.props.stopOnUnmount && (this.player.stop(), this.player.disablePIP && this.player.disablePIP()), this.mounted = !1;
    }
    componentDidUpdate(c) {
      if (!this.player)
        return;
      const { url: n, playing: C, volume: U, muted: B, playbackRate: W, pip: X, loop: N, activePlayer: I, disableDeferredLoading: k } = this.props;
      if (!(0, M.default)(c.url, n)) {
        if (this.isLoading && !I.forceLoad && !k && !(0, $.isMediaStream)(n)) {
          console.warn(`ReactPlayer: the attempt to load ${n} is being deferred until the player has loaded`), this.loadOnReady = n;
          return;
        }
        this.isLoading = !0, this.startOnPlay = !0, this.onDurationCalled = !1, this.player.load(n, this.isReady);
      }
      !c.playing && C && !this.isPlaying && this.player.play(), c.playing && !C && this.isPlaying && this.player.pause(), !c.pip && X && this.player.enablePIP && this.player.enablePIP(), c.pip && !X && this.player.disablePIP && this.player.disablePIP(), c.volume !== U && U !== null && this.player.setVolume(U), c.muted !== B && (B ? this.player.mute() : (this.player.unmute(), U !== null && setTimeout(() => this.player.setVolume(U)))), c.playbackRate !== W && this.player.setPlaybackRate && this.player.setPlaybackRate(W), c.loop !== N && this.player.setLoop && this.player.setLoop(N);
    }
    getDuration() {
      return this.isReady ? this.player.getDuration() : null;
    }
    getCurrentTime() {
      return this.isReady ? this.player.getCurrentTime() : null;
    }
    getSecondsLoaded() {
      return this.isReady ? this.player.getSecondsLoaded() : null;
    }
    seekTo(c, n, C) {
      if (!this.isReady) {
        c !== 0 && (this.seekOnPlay = c, setTimeout(() => {
          this.seekOnPlay = null;
        }, _));
        return;
      }
      if (n ? n === "fraction" : c > 0 && c < 1) {
        const B = this.player.getDuration();
        if (!B) {
          console.warn("ReactPlayer: could not seek using fraction – duration not yet available");
          return;
        }
        this.player.seekTo(B * c, C);
        return;
      }
      this.player.seekTo(c, C);
    }
    render() {
      const c = this.props.activePlayer;
      return c ? /* @__PURE__ */ w.default.createElement(
        c,
        {
          ...this.props,
          onMount: this.handlePlayerMount,
          onReady: this.handleReady,
          onPlay: this.handlePlay,
          onPause: this.handlePause,
          onEnded: this.handleEnded,
          onLoaded: this.handleLoaded,
          onError: this.handleError
        }
      ) : null;
    }
  }
  return i(b, "displayName", "Player"), i(b, "propTypes", A.propTypes), i(b, "defaultProps", A.defaultProps), xe;
}
var je, rt;
function pn() {
  if (rt) return je;
  rt = 1;
  var a = Object.create, l = Object.defineProperty, y = Object.getOwnPropertyDescriptor, u = Object.getOwnPropertyNames, v = Object.getPrototypeOf, r = Object.prototype.hasOwnProperty, o = (N, I, k) => I in N ? l(N, I, { enumerable: !0, configurable: !0, writable: !0, value: k }) : N[I] = k, h = (N, I) => {
    for (var k in I)
      l(N, k, { get: I[k], enumerable: !0 });
  }, d = (N, I, k, s) => {
    if (I && typeof I == "object" || typeof I == "function")
      for (let e of u(I))
        !r.call(N, e) && e !== k && l(N, e, { get: () => I[e], enumerable: !(s = y(I, e)) || s.enumerable });
    return N;
  }, O = (N, I, k) => (k = N != null ? a(v(N)) : {}, d(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    !N || !N.__esModule ? l(k, "default", { value: N, enumerable: !0 }) : k,
    N
  )), S = (N) => d(l({}, "__esModule", { value: !0 }), N), i = (N, I, k) => (o(N, typeof I != "symbol" ? I + "" : I, k), k), R = {};
  h(R, {
    createReactPlayer: () => X
  }), je = S(R);
  var w = O(he), M = O(At()), A = O(rn), $ = O(xt()), _ = /* @__PURE__ */ Mt(), b = /* @__PURE__ */ ye(), p = O(/* @__PURE__ */ dn());
  const c = (0, b.lazy)(() => import(
    /* webpackChunkName: 'reactPlayerPreview' */
    "./Preview-B9NNSPuj.js"
  ).then((N) => N.P)), n = typeof window < "u" && window.document && typeof document < "u", C = typeof _e < "u" && _e.window && _e.window.document, U = Object.keys(_.propTypes), B = n || C ? w.Suspense : () => null, W = [], X = (N, I) => {
    var k;
    return k = class extends w.Component {
      constructor() {
        super(...arguments), i(this, "state", {
          showPreview: !!this.props.light
        }), i(this, "references", {
          wrapper: (s) => {
            this.wrapper = s;
          },
          player: (s) => {
            this.player = s;
          }
        }), i(this, "handleClickPreview", (s) => {
          this.setState({ showPreview: !1 }), this.props.onClickPreview(s);
        }), i(this, "showPreview", () => {
          this.setState({ showPreview: !0 });
        }), i(this, "getDuration", () => this.player ? this.player.getDuration() : null), i(this, "getCurrentTime", () => this.player ? this.player.getCurrentTime() : null), i(this, "getSecondsLoaded", () => this.player ? this.player.getSecondsLoaded() : null), i(this, "getInternalPlayer", (s = "player") => this.player ? this.player.getInternalPlayer(s) : null), i(this, "seekTo", (s, e, g) => {
          if (!this.player)
            return null;
          this.player.seekTo(s, e, g);
        }), i(this, "handleReady", () => {
          this.props.onReady(this);
        }), i(this, "getActivePlayer", (0, A.default)((s) => {
          for (const e of [...W, ...N])
            if (e.canPlay(s))
              return e;
          return I || null;
        })), i(this, "getConfig", (0, A.default)((s, e) => {
          const { config: g } = this.props;
          return M.default.all([
            _.defaultProps.config,
            _.defaultProps.config[e] || {},
            g,
            g[e] || {}
          ]);
        })), i(this, "getAttributes", (0, A.default)((s) => (0, b.omit)(this.props, U))), i(this, "renderActivePlayer", (s) => {
          if (!s)
            return null;
          const e = this.getActivePlayer(s);
          if (!e)
            return null;
          const g = this.getConfig(s, e.key);
          return /* @__PURE__ */ w.default.createElement(
            p.default,
            {
              ...this.props,
              key: e.key,
              ref: this.references.player,
              config: g,
              activePlayer: e.lazyPlayer || e,
              onReady: this.handleReady
            }
          );
        });
      }
      shouldComponentUpdate(s, e) {
        return !(0, $.default)(this.props, s) || !(0, $.default)(this.state, e);
      }
      componentDidUpdate(s) {
        const { light: e } = this.props;
        !s.light && e && this.setState({ showPreview: !0 }), s.light && !e && this.setState({ showPreview: !1 });
      }
      renderPreview(s) {
        if (!s)
          return null;
        const { light: e, playIcon: g, previewTabIndex: z, oEmbedUrl: J, previewAriaLabel: P } = this.props;
        return /* @__PURE__ */ w.default.createElement(
          c,
          {
            url: s,
            light: e,
            playIcon: g,
            previewTabIndex: z,
            previewAriaLabel: P,
            oEmbedUrl: J,
            onClick: this.handleClickPreview
          }
        );
      }
      render() {
        const { url: s, style: e, width: g, height: z, fallback: J, wrapper: P } = this.props, { showPreview: t } = this.state, f = this.getAttributes(s), T = typeof P == "string" ? this.references.wrapper : void 0;
        return /* @__PURE__ */ w.default.createElement(P, { ref: T, style: { ...e, width: g, height: z }, ...f }, /* @__PURE__ */ w.default.createElement(B, { fallback: J }, t ? this.renderPreview(s) : this.renderActivePlayer(s)));
      }
    }, i(k, "displayName", "ReactPlayer"), i(k, "propTypes", _.propTypes), i(k, "defaultProps", _.defaultProps), i(k, "addCustomPlayer", (s) => {
      W.push(s);
    }), i(k, "removeCustomPlayers", () => {
      W.length = 0;
    }), i(k, "canPlay", (s) => {
      for (const e of [...W, ...N])
        if (e.canPlay(s))
          return !0;
      return !1;
    }), i(k, "canEnablePIP", (s) => {
      for (const e of [...W, ...N])
        if (e.canEnablePIP && e.canEnablePIP(s))
          return !0;
      return !1;
    }), k;
  };
  return je;
}
var Ne, nt;
function hn() {
  if (nt) return Ne;
  nt = 1;
  var a = Object.defineProperty, l = Object.getOwnPropertyDescriptor, y = Object.getOwnPropertyNames, u = Object.prototype.hasOwnProperty, v = (s, e) => {
    for (var g in e)
      a(s, g, { get: e[g], enumerable: !0 });
  }, r = (s, e, g, z) => {
    if (e && typeof e == "object" || typeof e == "function")
      for (let J of y(e))
        !u.call(s, J) && J !== g && a(s, J, { get: () => e[J], enumerable: !(z = l(e, J)) || z.enumerable });
    return s;
  }, o = (s) => r(a({}, "__esModule", { value: !0 }), s), h = {};
  v(h, {
    AUDIO_EXTENSIONS: () => U,
    DASH_EXTENSIONS: () => X,
    FLV_EXTENSIONS: () => N,
    HLS_EXTENSIONS: () => W,
    MATCH_URL_DAILYMOTION: () => p,
    MATCH_URL_FACEBOOK: () => w,
    MATCH_URL_FACEBOOK_WATCH: () => M,
    MATCH_URL_KALTURA: () => C,
    MATCH_URL_MIXCLOUD: () => c,
    MATCH_URL_MUX: () => R,
    MATCH_URL_SOUNDCLOUD: () => S,
    MATCH_URL_STREAMABLE: () => A,
    MATCH_URL_TWITCH_CHANNEL: () => b,
    MATCH_URL_TWITCH_VIDEO: () => _,
    MATCH_URL_VIDYARD: () => n,
    MATCH_URL_VIMEO: () => i,
    MATCH_URL_WISTIA: () => $,
    MATCH_URL_YOUTUBE: () => O,
    VIDEO_EXTENSIONS: () => B,
    canPlay: () => k
  }), Ne = o(h);
  var d = /* @__PURE__ */ ye();
  const O = /(?:youtu\.be\/|youtube(?:-nocookie|education)?\.com\/(?:embed\/|v\/|watch\/|watch\?v=|watch\?.+&v=|shorts\/|live\/))((\w|-){11})|youtube\.com\/playlist\?list=|youtube\.com\/user\//, S = /(?:soundcloud\.com|snd\.sc)\/[^.]+$/, i = /vimeo\.com\/(?!progressive_redirect).+/, R = /stream\.mux\.com\/(?!\w+\.m3u8)(\w+)/, w = /^https?:\/\/(www\.)?facebook\.com.*\/(video(s)?|watch|story)(\.php?|\/).+$/, M = /^https?:\/\/fb\.watch\/.+$/, A = /streamable\.com\/([a-z0-9]+)$/, $ = /(?:wistia\.(?:com|net)|wi\.st)\/(?:medias|embed)\/(?:iframe\/)?([^?]+)/, _ = /(?:www\.|go\.)?twitch\.tv\/videos\/(\d+)($|\?)/, b = /(?:www\.|go\.)?twitch\.tv\/([a-zA-Z0-9_]+)($|\?)/, p = /^(?:(?:https?):)?(?:\/\/)?(?:www\.)?(?:(?:dailymotion\.com(?:\/embed)?\/video)|dai\.ly)\/([a-zA-Z0-9]+)(?:_[\w_-]+)?(?:[\w.#_-]+)?/, c = /mixcloud\.com\/([^/]+\/[^/]+)/, n = /vidyard.com\/(?:watch\/)?([a-zA-Z0-9-_]+)/, C = /^https?:\/\/[a-zA-Z]+\.kaltura.(com|org)\/p\/([0-9]+)\/sp\/([0-9]+)00\/embedIframeJs\/uiconf_id\/([0-9]+)\/partner_id\/([0-9]+)(.*)entry_id.([a-zA-Z0-9-_].*)$/, U = /\.(m4a|m4b|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx)($|\?)/i, B = /\.(mp4|og[gv]|webm|mov|m4v)(#t=[,\d+]+)?($|\?)/i, W = /\.(m3u8)($|\?)/i, X = /\.(mpd)($|\?)/i, N = /\.(flv)($|\?)/i, I = (s) => {
    if (s instanceof Array) {
      for (const e of s)
        if (typeof e == "string" && I(e) || I(e.src))
          return !0;
      return !1;
    }
    return (0, d.isMediaStream)(s) || (0, d.isBlobUrl)(s) ? !0 : U.test(s) || B.test(s) || W.test(s) || X.test(s) || N.test(s);
  }, k = {
    youtube: (s) => s instanceof Array ? s.every((e) => O.test(e)) : O.test(s),
    soundcloud: (s) => S.test(s) && !U.test(s),
    vimeo: (s) => i.test(s) && !B.test(s) && !W.test(s),
    mux: (s) => R.test(s),
    facebook: (s) => w.test(s) || M.test(s),
    streamable: (s) => A.test(s),
    wistia: (s) => $.test(s),
    twitch: (s) => _.test(s) || b.test(s),
    dailymotion: (s) => p.test(s),
    mixcloud: (s) => c.test(s),
    vidyard: (s) => n.test(s),
    kaltura: (s) => C.test(s),
    file: I
  };
  return Ne;
}
var Me, at;
function yn() {
  if (at) return Me;
  at = 1;
  var a = Object.create, l = Object.defineProperty, y = Object.getOwnPropertyDescriptor, u = Object.getOwnPropertyNames, v = Object.getPrototypeOf, r = Object.prototype.hasOwnProperty, o = (s, e, g) => e in s ? l(s, e, { enumerable: !0, configurable: !0, writable: !0, value: g }) : s[e] = g, h = (s, e) => {
    for (var g in e)
      l(s, g, { get: e[g], enumerable: !0 });
  }, d = (s, e, g, z) => {
    if (e && typeof e == "object" || typeof e == "function")
      for (let J of u(e))
        !r.call(s, J) && J !== g && l(s, J, { get: () => e[J], enumerable: !(z = y(e, J)) || z.enumerable });
    return s;
  }, O = (s, e, g) => (g = s != null ? a(v(s)) : {}, d(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    !s || !s.__esModule ? l(g, "default", { value: s, enumerable: !0 }) : g,
    s
  )), S = (s) => d(l({}, "__esModule", { value: !0 }), s), i = (s, e, g) => (o(s, typeof e != "symbol" ? e + "" : e, g), g), R = {};
  h(R, {
    default: () => k
  }), Me = S(R);
  var w = O(he), M = /* @__PURE__ */ ye(), A = /* @__PURE__ */ hn();
  const $ = typeof navigator < "u", _ = $ && navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1, b = $ && (/iPad|iPhone|iPod/.test(navigator.userAgent) || _) && !window.MSStream, p = $ && /^((?!chrome|android).)*safari/i.test(navigator.userAgent) && !window.MSStream, c = "https://cdn.jsdelivr.net/npm/hls.js@VERSION/dist/hls.min.js", n = "Hls", C = "https://cdnjs.cloudflare.com/ajax/libs/dashjs/VERSION/dash.all.min.js", U = "dashjs", B = "https://cdn.jsdelivr.net/npm/flv.js@VERSION/dist/flv.min.js", W = "flvjs", X = /www\.dropbox\.com\/.+/, N = /https:\/\/watch\.cloudflarestream\.com\/([a-z0-9]+)/, I = "https://videodelivery.net/{id}/manifest/video.m3u8";
  class k extends w.Component {
    constructor() {
      super(...arguments), i(this, "onReady", (...e) => this.props.onReady(...e)), i(this, "onPlay", (...e) => this.props.onPlay(...e)), i(this, "onBuffer", (...e) => this.props.onBuffer(...e)), i(this, "onBufferEnd", (...e) => this.props.onBufferEnd(...e)), i(this, "onPause", (...e) => this.props.onPause(...e)), i(this, "onEnded", (...e) => this.props.onEnded(...e)), i(this, "onError", (...e) => this.props.onError(...e)), i(this, "onPlayBackRateChange", (e) => this.props.onPlaybackRateChange(e.target.playbackRate)), i(this, "onEnablePIP", (...e) => this.props.onEnablePIP(...e)), i(this, "onDisablePIP", (e) => {
        const { onDisablePIP: g, playing: z } = this.props;
        g(e), z && this.play();
      }), i(this, "onPresentationModeChange", (e) => {
        if (this.player && (0, M.supportsWebKitPresentationMode)(this.player)) {
          const { webkitPresentationMode: g } = this.player;
          g === "picture-in-picture" ? this.onEnablePIP(e) : g === "inline" && this.onDisablePIP(e);
        }
      }), i(this, "onSeek", (e) => {
        this.props.onSeek(e.target.currentTime);
      }), i(this, "mute", () => {
        this.player.muted = !0;
      }), i(this, "unmute", () => {
        this.player.muted = !1;
      }), i(this, "renderSourceElement", (e, g) => typeof e == "string" ? /* @__PURE__ */ w.default.createElement("source", { key: g, src: e }) : /* @__PURE__ */ w.default.createElement("source", { key: g, ...e })), i(this, "renderTrack", (e, g) => /* @__PURE__ */ w.default.createElement("track", { key: g, ...e })), i(this, "ref", (e) => {
        this.player && (this.prevPlayer = this.player), this.player = e;
      });
    }
    componentDidMount() {
      this.props.onMount && this.props.onMount(this), this.addListeners(this.player);
      const e = this.getSource(this.props.url);
      e && (this.player.src = e), (b || this.props.config.forceDisableHls) && this.player.load();
    }
    componentDidUpdate(e) {
      this.shouldUseAudio(this.props) !== this.shouldUseAudio(e) && (this.removeListeners(this.prevPlayer, e.url), this.addListeners(this.player)), this.props.url !== e.url && !(0, M.isMediaStream)(this.props.url) && !(this.props.url instanceof Array) && (this.player.srcObject = null);
    }
    componentWillUnmount() {
      this.player.removeAttribute("src"), this.removeListeners(this.player), this.hls && this.hls.destroy();
    }
    addListeners(e) {
      const { url: g, playsinline: z } = this.props;
      e.addEventListener("play", this.onPlay), e.addEventListener("waiting", this.onBuffer), e.addEventListener("playing", this.onBufferEnd), e.addEventListener("pause", this.onPause), e.addEventListener("seeked", this.onSeek), e.addEventListener("ended", this.onEnded), e.addEventListener("error", this.onError), e.addEventListener("ratechange", this.onPlayBackRateChange), e.addEventListener("enterpictureinpicture", this.onEnablePIP), e.addEventListener("leavepictureinpicture", this.onDisablePIP), e.addEventListener("webkitpresentationmodechanged", this.onPresentationModeChange), this.shouldUseHLS(g) || e.addEventListener("canplay", this.onReady), z && (e.setAttribute("playsinline", ""), e.setAttribute("webkit-playsinline", ""), e.setAttribute("x5-playsinline", ""));
    }
    removeListeners(e, g) {
      e.removeEventListener("canplay", this.onReady), e.removeEventListener("play", this.onPlay), e.removeEventListener("waiting", this.onBuffer), e.removeEventListener("playing", this.onBufferEnd), e.removeEventListener("pause", this.onPause), e.removeEventListener("seeked", this.onSeek), e.removeEventListener("ended", this.onEnded), e.removeEventListener("error", this.onError), e.removeEventListener("ratechange", this.onPlayBackRateChange), e.removeEventListener("enterpictureinpicture", this.onEnablePIP), e.removeEventListener("leavepictureinpicture", this.onDisablePIP), e.removeEventListener("webkitpresentationmodechanged", this.onPresentationModeChange), this.shouldUseHLS(g) || e.removeEventListener("canplay", this.onReady);
    }
    shouldUseAudio(e) {
      return e.config.forceVideo || e.config.attributes.poster ? !1 : A.AUDIO_EXTENSIONS.test(e.url) || e.config.forceAudio;
    }
    shouldUseHLS(e) {
      return p && this.props.config.forceSafariHLS || this.props.config.forceHLS ? !0 : b || this.props.config.forceDisableHls ? !1 : A.HLS_EXTENSIONS.test(e) || N.test(e);
    }
    shouldUseDASH(e) {
      return A.DASH_EXTENSIONS.test(e) || this.props.config.forceDASH;
    }
    shouldUseFLV(e) {
      return A.FLV_EXTENSIONS.test(e) || this.props.config.forceFLV;
    }
    load(e) {
      const { hlsVersion: g, hlsOptions: z, dashVersion: J, flvVersion: P } = this.props.config;
      if (this.hls && this.hls.destroy(), this.dash && this.dash.reset(), this.shouldUseHLS(e) && (0, M.getSDK)(c.replace("VERSION", g), n).then((t) => {
        if (this.hls = new t(z), this.hls.on(t.Events.MANIFEST_PARSED, () => {
          this.props.onReady();
        }), this.hls.on(t.Events.ERROR, (f, T) => {
          this.props.onError(f, T, this.hls, t);
        }), N.test(e)) {
          const f = e.match(N)[1];
          this.hls.loadSource(I.replace("{id}", f));
        } else
          this.hls.loadSource(e);
        this.hls.attachMedia(this.player), this.props.onLoaded();
      }), this.shouldUseDASH(e) && (0, M.getSDK)(C.replace("VERSION", J), U).then((t) => {
        this.dash = t.MediaPlayer().create(), this.dash.initialize(this.player, e, this.props.playing), this.dash.on("error", this.props.onError), parseInt(J) < 3 ? this.dash.getDebug().setLogToBrowserConsole(!1) : this.dash.updateSettings({ debug: { logLevel: t.Debug.LOG_LEVEL_NONE } }), this.props.onLoaded();
      }), this.shouldUseFLV(e) && (0, M.getSDK)(B.replace("VERSION", P), W).then((t) => {
        this.flv = t.createPlayer({ type: "flv", url: e }), this.flv.attachMediaElement(this.player), this.flv.on(t.Events.ERROR, (f, T) => {
          this.props.onError(f, T, this.flv, t);
        }), this.flv.load(), this.props.onLoaded();
      }), e instanceof Array)
        this.player.load();
      else if ((0, M.isMediaStream)(e))
        try {
          this.player.srcObject = e;
        } catch {
          this.player.src = window.URL.createObjectURL(e);
        }
    }
    play() {
      const e = this.player.play();
      e && e.catch(this.props.onError);
    }
    pause() {
      this.player.pause();
    }
    stop() {
      this.player.removeAttribute("src"), this.dash && this.dash.reset();
    }
    seekTo(e, g = !0) {
      this.player.currentTime = e, g || this.pause();
    }
    setVolume(e) {
      this.player.volume = e;
    }
    enablePIP() {
      this.player.requestPictureInPicture && document.pictureInPictureElement !== this.player ? this.player.requestPictureInPicture() : (0, M.supportsWebKitPresentationMode)(this.player) && this.player.webkitPresentationMode !== "picture-in-picture" && this.player.webkitSetPresentationMode("picture-in-picture");
    }
    disablePIP() {
      document.exitPictureInPicture && document.pictureInPictureElement === this.player ? document.exitPictureInPicture() : (0, M.supportsWebKitPresentationMode)(this.player) && this.player.webkitPresentationMode !== "inline" && this.player.webkitSetPresentationMode("inline");
    }
    setPlaybackRate(e) {
      try {
        this.player.playbackRate = e;
      } catch (g) {
        this.props.onError(g);
      }
    }
    getDuration() {
      if (!this.player)
        return null;
      const { duration: e, seekable: g } = this.player;
      return e === 1 / 0 && g.length > 0 ? g.end(g.length - 1) : e;
    }
    getCurrentTime() {
      return this.player ? this.player.currentTime : null;
    }
    getSecondsLoaded() {
      if (!this.player)
        return null;
      const { buffered: e } = this.player;
      if (e.length === 0)
        return 0;
      const g = e.end(e.length - 1), z = this.getDuration();
      return g > z ? z : g;
    }
    getSource(e) {
      const g = this.shouldUseHLS(e), z = this.shouldUseDASH(e), J = this.shouldUseFLV(e);
      if (!(e instanceof Array || (0, M.isMediaStream)(e) || g || z || J))
        return X.test(e) ? e.replace("www.dropbox.com", "dl.dropboxusercontent.com") : e;
    }
    render() {
      const { url: e, playing: g, loop: z, controls: J, muted: P, config: t, width: f, height: T } = this.props, j = this.shouldUseAudio(this.props) ? "audio" : "video", H = {
        width: f === "auto" ? f : "100%",
        height: T === "auto" ? T : "100%"
      };
      return /* @__PURE__ */ w.default.createElement(
        j,
        {
          ref: this.ref,
          src: this.getSource(e),
          style: H,
          preload: "auto",
          autoPlay: g || void 0,
          controls: J,
          muted: P,
          loop: z,
          ...t.attributes
        },
        e instanceof Array && e.map(this.renderSourceElement),
        t.tracks.map(this.renderTrack)
      );
    }
  }
  return i(k, "displayName", "FilePlayer"), i(k, "canPlay", A.canPlay.file), Me;
}
var Ie, st;
function _n() {
  if (st) return Ie;
  st = 1;
  var a = pn().createReactPlayer, l = yn().default;
  return Ie = a([{
    key: "file",
    canPlay: l.canPlay,
    lazyPlayer: l
  }]), Ie;
}
var vn = /* @__PURE__ */ _n();
const mn = /* @__PURE__ */ Yt(vn), bn = "_root_24566_12", gn = "_playButton_24566_28", ot = {
  root: bn,
  playButton: gn
}, It = "VideoCard";
function Lt({ video: a, className: l, ...y }, u) {
  const [v, r] = Jt(!1);
  return /* @__PURE__ */ m.jsx(
    ae,
    {
      ref: u,
      variant: "bare",
      className: Z(
        "airc-ui__" + Q(It),
        ee(l)
      ),
      ...y,
      style: {
        ...y.style ? y.style : {},
        borderRadius: "var(--airc-ui__radius-m)"
      },
      children: /* @__PURE__ */ m.jsx("div", { className: ot.root, children: /* @__PURE__ */ m.jsx(
        mn,
        {
          url: a.src,
          playing: v,
          onPlay: () => r(!0),
          onPause: () => {
            v && r(!1);
          },
          width: "100%",
          height: "100%",
          loop: !0,
          muted: !0,
          controls: !0,
          playsinline: !0,
          playIcon: /* @__PURE__ */ m.jsx(
            Kt,
            {
              onClick: () => r(!0),
              className: ot.playButton
            }
          ),
          light: a.poster
        }
      ) })
    }
  );
}
Lt.displayName = It;
const Mn = te(
  Lt
);
export {
  On as A,
  Sn as E,
  wn as H,
  Cn as I,
  An as P,
  xn as S,
  jn as T,
  Mn as V,
  Tn as a,
  Rn as b,
  Nn as c
};
//# sourceMappingURL=index-D0jMQcXx.js.map
